/**
 * Generic Tooltips
 *
 * @module
 */

import { $$ } from '../../utilities/QuerySelectors.js';
import { computePosition, autoUpdate } from '@floating-ui/dom';

export class Tooltip {
    /**
     * Create a tooltip instance to display near the given reference element.
     *
     * The name is used to both match an element to use as the modal container
     * and to find the data to display.
     *
     * @private
     * @param {string} name Name matching a modal element inside the document.
     * @param {HTMLElement} dataProviderElement
     */
    constructor(name, dataProviderElement) {
        this.name = name;
        this.dataProviderElement = dataProviderElement;
        this.attributes = {};
        this.modal = null;
        this.autoUpdateStopper = null;
        console.log('Tooltip', name, dataProviderElement);
    }

    extractAttributes() {
        const attributeName = 'data-' + this.name + '-attribute';
        $$(`[${attributeName}]`, this.dataProviderElement).map(el => {
            const attributeValue = el.getAttribute(attributeName + '-value');
            this.attributes[el.getAttribute(attributeName)] = attributeValue ? attributeValue : el.innerHTML;
        })
        console.log('Tooltip.extractAttributes', this.attributes);
    }

    hydrateModal() {
        this.modal = document.getElementById(this.name + '-modal');
        Object.keys(this.attributes).forEach(name => {
            this.modal.querySelector(`.${this.name}-${name}`).innerHTML = this.attributes[name];
        });
    }

    show(reference, floating, onShow = null) {
        this.autoUpdateStopper = autoUpdate(reference, floating, () => {
            computePosition(reference, floating, {
                placement: 'top',
            }).then(({x, y}) => {
                Object.assign(floating.style, {
                    left: `${x}px`,
                    top: `${y}px`,
                });
                if (onShow) {
                    onShow();
                }
            });
        });
        console.log('Tooltip.show', this.modal, reference, floating);
    }

    kill(floating) {
        if (!this.autoUpdateStopper) {
            return;
        }

        this.autoUpdateStopper();

        Object.assign(floating.style, {
            left: ``,
            top: ``,
        });
    }

    init() {
        this.extractAttributes();
        this.hydrateModal();
    }
}
